// Mining Contract Configuration
export const MINING_CONTRACT_ADDRESS = "0xAfCbaC0867333105164316D89B5468294d79ee22";
export const CORE_TOKEN_ADDRESS = "0xd74eEFB91c31E382590AaB62c4F6142b3f234874";

// Deployment date for listing progress calculation (January 6, 2026)
export const DEPLOYMENT_DATE = new Date('2026-01-06T00:00:00Z');
export const LISTING_DURATION_DAYS = 2000;

// opBNBscan URL
export const OPBNB_SCAN_URL = "https://opbnbscan.com";

// Telegram API
export const TELEGRAM_API_URL = "https://smartcore.live/api/telegram.php";
export const TELEGRAM_BOT_USERNAME = "@smartcore_reports_bot";
export const TELEGRAM_CHANNEL_URL = "https://t.me/smartcore_official";

// Mining Contract ABI (v2 - with pending system)
export const MINING_CONTRACT_ABI = [
  {
    "inputs": [],
    "name": "getCurrentDay",
    "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "paused",
    "outputs": [{"internalType": "bool", "name": "", "type": "bool"}],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getGlobalStats",
    "outputs": [
      {"internalType": "uint256", "name": "_totalMiners", "type": "uint256"},
      {"internalType": "uint256", "name": "_totalEnergyDistributed", "type": "uint256"},
      {"internalType": "uint256", "name": "_totalTokensMined", "type": "uint256"},
      {"internalType": "uint256", "name": "_totalTokensWithdrawn", "type": "uint256"},
      {"internalType": "bool", "name": "_paused", "type": "bool"},
      {"internalType": "uint256", "name": "_currentDay", "type": "uint256"}
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [{"internalType": "address", "name": "user", "type": "address"}],
    "name": "getUserStats",
    "outputs": [
      {"internalType": "uint256", "name": "smartcoreUserId", "type": "uint256"},
      {"internalType": "uint256", "name": "totalEnergy", "type": "uint256"},
      {"internalType": "uint256", "name": "availableEnergy", "type": "uint256"},
      {"internalType": "uint256", "name": "totalMined", "type": "uint256"},
      {"internalType": "uint256", "name": "pendingBalance", "type": "uint256"},
      {"internalType": "uint256", "name": "withdrawableBalance", "type": "uint256"},
      {"internalType": "uint256", "name": "totalWithdrawn", "type": "uint256"},
      {"internalType": "uint256", "name": "lastMinedDay", "type": "uint256"},
      {"internalType": "uint256", "name": "sessionCount", "type": "uint256"},
      {"internalType": "bool", "name": "canMineToday", "type": "bool"}
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [{"internalType": "address", "name": "user", "type": "address"}],
    "name": "getTodaysMiningReward",
    "outputs": [
      {"internalType": "uint256", "name": "reward", "type": "uint256"},
      {"internalType": "uint256", "name": "activeSessions", "type": "uint256"}
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [{"internalType": "address", "name": "user", "type": "address"}],
    "name": "getUserActiveSessions",
    "outputs": [
      {"internalType": "uint256[]", "name": "sessionIds", "type": "uint256[]"},
      {"internalType": "uint256[]", "name": "dailyRewards", "type": "uint256[]"},
      {"internalType": "uint256[]", "name": "daysRemaining", "type": "uint256[]"}
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [{"internalType": "address", "name": "user", "type": "address"}],
    "name": "checkSyncAvailable",
    "outputs": [
      {"internalType": "bool", "name": "hasNewInvestments", "type": "bool"},
      {"internalType": "uint256", "name": "totalNewEnergy", "type": "uint256"},
      {"internalType": "uint256[8]", "name": "newInvestmentPerPackage", "type": "uint256[8]"}
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [{"internalType": "address", "name": "user", "type": "address"}],
    "name": "isSmartcoreUser",
    "outputs": [
      {"internalType": "bool", "name": "", "type": "bool"},
      {"internalType": "uint256", "name": "", "type": "uint256"}
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "syncFromSmartcore",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "mine",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "claimPending",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "withdraw",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [{"internalType": "uint256", "name": "amount", "type": "uint256"}],
    "name": "withdrawAmount",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  }
];

// CORE Token ABI
export const CORE_TOKEN_ABI = [
  {
    "inputs": [],
    "name": "totalSupply",
    "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [{"internalType": "address", "name": "account", "type": "address"}],
    "name": "balanceOf",
    "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
    "stateMutability": "view",
    "type": "function"
  }
];

// Helper functions
export const getListingProgress = () => {
  const now = new Date();
  const daysPassed = Math.floor((now - DEPLOYMENT_DATE) / (1000 * 60 * 60 * 24));
  const progress = Math.min((daysPassed / LISTING_DURATION_DAYS) * 100, 100);
  return {
    daysPassed: Math.max(0, daysPassed),
    totalDays: LISTING_DURATION_DAYS,
    percentage: progress.toFixed(3),
    isComplete: progress >= 100
  };
};

export const formatCore = (value) => {
  if (!value) return '0.00';
  const num = parseFloat(value) / 1e18;
  if (num >= 1000000) return (num / 1000000).toFixed(2) + 'M';
  if (num >= 1000) return (num / 1000).toFixed(2) + 'K';
  return num.toFixed(4);
};

export const formatNumber = (num) => {
  if (!num) return '0';
  const n = parseFloat(num);
  if (n >= 1000000) return (n / 1000000).toFixed(2) + 'M';
  if (n >= 1000) return (n / 1000).toFixed(2) + 'K';
  return n.toLocaleString();
};

export const getTokenLink = () => `${OPBNB_SCAN_URL}/token/${CORE_TOKEN_ADDRESS}`;
export const getMiningContractLink = () => `${OPBNB_SCAN_URL}/address/${MINING_CONTRACT_ADDRESS}`;
